<template>
  <v-container fluid>
    <v-card>
      <v-container class="ma-0 pa-0" fluid>
        <v-container grid-list-xs fluid class="mb-0 pb-0" style="padding: 5px;">
          <v-layout row style="padding: 10px;">
            <v-layout>
              <!-- <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="Date From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateFrom"
                    :max="dateTo"
                    min="1950-01-01"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>-->
              <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="Date"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateTo"
                    :max="new Date().toISOString().substr(0, 10)"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <!-- <v-flex md6>
              <v-text-field
                ref="form"
                class="mr-1"
                prepend-icon="search"
                label="Search"
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-flex>-->
            <v-spacer></v-spacer>
            <!-- <v-select
            v-model="theTableStyle"
            :items="tableItems"
            prepend-icon="table_chart"
            label="Type of Table"
            style="width: 0.10%;"
            ></v-select>-->
            <v-btn fab dark small color="amber darken-2" @click="getData">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel File</span>
            </v-tooltip>
            <refresh-button @refresh="refreshTable()"></refresh-button>
          </v-layout>
          <!-- <v-container grid-list-lg fluid style="padding: 0px;" class="pt-3">
          </v-container>-->
        </v-container>
        <!-- Filter -->
        <!-- <v-divider></v-divider> -->
        <v-layout row>
          <v-flex sm4 md4>
            <!-- <v-btn flat @click="openFilterExpansion">
              <v-icon class="mr-3">{{ openFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
              <span>Filter {{ title }}</span>
            </v-btn>-->
          </v-flex>
        </v-layout>
        <filter-panel :openFilter="openFilter">
          <v-flex md4 v-if="$store.state.companies.length">
            <v-select
              v-model="filterCompany"
              :items="filterCompanies"
              label="By Company"
              solo
              clearable
            ></v-select>
          </v-flex>
          <v-flex md4 v-if="$store.state.sub_companies.length">
            <v-select
              v-model="filterSubCompany"
              :items="filterSubCompanies"
              label="By Sub-Company"
              solo
              clearable
            ></v-select>
          </v-flex>
        </filter-panel>
        <v-divider></v-divider>
        <v-data-table :headers="headers" :items="items" hide-actions disable-initial-sort>
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                    'column sortable', 
                    header.value === queryParams.order ? 'active' : '', 
                    'text-xs-'+header.align
                  ]"
              >
                <span>{{ header.text.toUpperCase() }}</span>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center" data-v-72e44d1a>{{ props.index + 1}}</td>
            <td class="text-xs-left text-uppercase">{{ props.item.device_serial }}</td>
            <td class="text-xs-left text-uppercase">{{ props.item.control_no }}</td>
            <!-- <td
              class="text-xs-left text-uppercase"
            >{{ props.item.driver_name === null ? '--' : props.item.driver_name }}</td> -->
            <!-- <td
              class="text-xs-left text-uppercase"
            >{{ props.item.conductor_name === null ? '--' : props.item.conductor_name }}</td> -->
            <td
              class="text-xs-left text-uppercase"
            >{{ props.item.teller_name === null ? '--' : props.item.teller_name }}</td>
            <!-- <td class="text-xs-right">{{ $amountInPeso(props.item.cash_sales) }}</td>
            <td class="text-xs-right">{{ $amountInPeso(props.item.card_sales) }}</td>
            <td class="text-xs-right">{{ $amountInPeso(props.item.reserved_sales) }}</td> -->
            <td class="text-xs-right">{{ $amountInPeso(props.item.gross_sales) }}</td>
          </template>
          <template v-if="items.length !== 0" slot="footer">
            <td class="text-xs-center font-weight-bold">Total:</td>
            <td class="text-xs-center"></td>
            <td class="text-xs-center"></td>
            <!-- <td class="text-xs-center"></td>
            <td class="text-xs-center"></td> -->
            <td class="text-xs-center"></td>
            <!-- <td class="text-xs-right">{{ $amountInPeso(totalItems.total_cash_sales) }}</td>
            <td class="text-xs-right">{{ $amountInPeso(totalItems.total_card_sales) }}</td>
            <td class="text-xs-right">{{ $amountInPeso(totalItems.total_reserved_sales) }}</td> -->
            <td class="text-xs-right">{{ $amountInPeso(totalItems.total_gross_sales) }}</td>
          </template>
        </v-data-table>
      </v-container>
      <!-- 
        <v-container fluid>
          <v-layout>
            <v-flex md9>
              <v-layout class="scrolling-wrapper">
                <v-flex v-for="(dates, index) in items" :key="index">
                  <v-card>
                    {{dates}}
                    <v-data-table :headers="dates.header" :items="dates.data" hide-actions>
                      <template slot="headers" slot-scope="props">
                        <tr>
                          <th>{{ props.headers }}</th>
                        </tr>
                      </template>
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.value }}</td>
                      </template>
                      <template slot="footer">
                        <td class="text-xs-right" width="10px">
                          <strong>{{ $amountInPeso(dates.total.amount) }}</strong>
                        </td>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
      </v-container>-->
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
import XLSX from "xlsx";
const now = new Date();

export default {
  data() {
    return {
      //For filter
      openFilter: false,
      filterCompanies: [],
      filterCompany: null,
      filterSubCompanies: [],
      filterSubCompany: null,

      title: "Device Daily Sales Report",
      timeOut: null,
      theTableStyle: false,
      tableItems: [
        {
          text: "Default Table",
          value: false
        },
        {
          text: "Grid Style Table",
          value: true
        }
      ],
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Device Serial",
          align: "left",
          sortable: false
        },
        {
          text: "Control No.",
          align: "left",
          sortable: false
        },
        // {
        //   text: "Driver Name",
        //   align: "left",
        //   sortable: false
        // },
        // {
        //   text: "Conductor Name",
        //   align: "left",
        //   sortable: false
        // },
        {
          text: "Cashier Name",
          align: "left",
          sortable: false
        },
        // {
        //   text: "Cash Sales",
        //   align: "right",
        //   sortable: false
        // },
        // {
        //   text: "Card Sales",
        //   align: "right",
        //   sortable: false
        // },
        // {
        //   text: "Reserved Sales",
        //   align: "right",
        //   sortable: false
        // },
        {
          text: "Gross Sales",
          align: "right",
          sortable: false
        }
      ],
      items: [],
      totalItems: {},
      queryParams: {
        search: "",
        company_id: null,
        sub_company_id: null,
        date: null,
      },
      menu: false,
      menu1: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD")
    };
  },
  computed: {
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      }
    }
  },
  //For filter
  watch: {
    filterCompany: async function() {
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.company_id = this.filterCompany;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.company_id = null;
        this.getData();
      }
    },
    filterSubCompany: async function() {
      if (
        this.filterSubCompany !== null &&
        this.filterSubCompany !== undefined &&
        this.filterSubCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = this.filterSubCompany;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = null;
        this.getData();
      }
    }
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$store.dispatch("startLoading");

      // this.queryParams.date_from = this.dateFrom;
      this.queryParams.date = this.dateTo;
      this.queryParams.company_id = this.$store.state.company.id;
      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      try {
        // Query Data
        let response = (await Services.getDeviceDailySales(this.queryParams))
          .data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;
        this.totalItems = response;
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    refreshTable() {
      this.getData();
    },
    //For filter
    async setFilterCompanies() {
      this.$store.state.companies.map(item => {
        let body = {
          text: item.name.toUpperCase(),
          value: item.id
        };
        this.filterCompanies.push(body);
      });
    },
    async setFilterSubCompanies() {
      this.$store.state.sub_companies.map(item => {
        let body = {
          text: item.name.toUpperCase(),
          value: item.id
        };
        this.filterSubCompanies.push(body);
      });
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterCompanies();
      await this.setFilterSubCompanies();
    },
    downloadExcel() {
      const wscols = [];
      const dataToDownload = [];
      const header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();
      header.unshift("");
      dataToDownload.push(header);

      for (let i = 0; i < this.headers.length; i++) {
        wscols.push({ wch: 10 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 35 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
      }

      for (let e = 0; e < this.items.length; e++) {
        const theItem = [];

        theItem.push("");
        theItem.push(
          this.items[e].device_serial
            ? this.items[e].device_serial.toUpperCase()
            : "--"
        );
        theItem.push(
          this.items[e].control_no
            ? this.items[e].control_no.toUpperCase()
            : "--"
        );
        // theItem.push(
        //   this.items[e].driver_name
        //     ? this.items[e].driver_name.toUpperCase()
        //     : "--"
        // );
        // theItem.push(
        //   this.items[e].conductor_name
        //     ? this.items[e].conductor_name.toUpperCase()
        //     : "--"
        // );
        theItem.push(
          this.items[e].teller_name
            ? this.items[e].teller_name.toUpperCase()
            : "--"
        );
        // theItem.push(this.items[e].cash_sales);
        // theItem.push(this.items[e].card_sales);
        // theItem.push(this.items[e].reserved_sales);
        theItem.push(this.items[e].gross_sales);

        dataToDownload.push(theItem);
      }

      for (let e = 0; e < 1; e++) {
        const theItem_2 = [];

        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");

        dataToDownload.push(theItem_2);
      }

      const totalItems = [
        "TOTAL",
        "",
        "",
        // "",
        // "",
        "",
        // this.totalItems.total_cash_sales,
        // this.totalItems.total_card_sales,
        // this.totalItems.total_reserved_sales,
        this.totalItems.total_gross_sales
      ];

      dataToDownload.push(totalItems);

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports"
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"]
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf"
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    }
  }
};
</script>

<style scoped>
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>